import React from 'react'

import { ReactComponent as FooterLogo } from '../img/footer_logo.svg'

import '../styles/footer.css'

const Footer: React.FC = () => {
  const activeYear = new Date().getFullYear()
  return (
    <footer>
      <div className="footer-text">
        <span className="footer-bold">Disclaimer : </span>PEXA Refinance Index (the “Index”) provides general market
        information, and does not constitute investment advice or financial product advice. Any representations,
        forecasts or trends displayed in the Index are based on information available to Property Exchange Australia
        Limited (“PEXA”) at the time of its compilation. No representation or warranty (express or implied) is made as
        to the accuracy, reliability or completeness of any representations, forecasts or trends made in the Index,
        which may be subject to change without notice, and may differ or be contrary to similar information provided by
        other analysts. Our analysis is based on a number of assumptions and estimates which are subject to
        contingencies and uncertainties. Different assumptions and estimates could yield different results. Neither
        PEXA, its ultimate holding company or any subsidiary of its ultimate holding company (the “PEXA Group”),
        represents or warrants that any representations, forecasts or trends, or any of the underlying assumptions or
        estimates, will be met. Whilst we endeavour to provide the most up-to-date information, the PEXA Group is under
        no obligation to update or keep current the information contained in the Index at any given time. To the maximum
        extent permitted by law, the PEXA Group does not accept any liability (including, without limitation, any
        liability arising out of fault or negligence) for any loss, expenses, damages or costs arising from the use of
        all or any part of the Index. Anyone proposing to rely on the information contained in the Index should
        independently verify the accuracy, completeness, reliability and suitability of the information and, if
        required, obtain independent professional advice.
        <br />
        <br />
        Information used to compile this index was sourced from the PEXA System with the approval from the relevant
        Registrar of Titles and, where applicable, the approval of their relevant service provider in the relevant
        jurisdictions. The relevant State Governments do not accept any responsibility for the accuracy, currency or
        completeness of the information or its suitability for any purpose.
        <br />
        <br />
        The relevant State Governments do not accept any responsibility for any reliance placed by any person upon the
        information, or the software by which it is provided. Persons acquiring or using the information and its
        associated software must exercise their independent judgement in doing so.
        <p>
          <span className="super">1</span> Data available for NSW, VIC, QLD, WA & SA (index excludes TAS, ACT and NT).
          Data source: PEXA, Land Services SA
          <br />
          <span className="super">2</span> The index is calculated using refinances completed via the PEXA exchange on
          the date of settlement. PEXA has captured over 95% of property refinances in NSW, VIC, WA & SA from 15 Oct
          2018. In QLD this level of coverage was obtained from 1 June 2019. For the period of 15 Oct 2018 to 1 June
          2019, QLD data has been normalised to represent total refinances.
          <br />
          <span className="super">3</span> Volume refers to the number of property refinances completed, shown weekly.
          <br />
          <span className="super">4</span> Value refers to the movement of the median monetary amount of settlement
          transactions that occur per week. It should be noted that the median value is of discharged mortgages not the
          newly refinanced mortgages. For example if an owner had $500K outstanding on their home loan and decided to
          refinance a new amount of $550K, the $500K is used the calculation not the $550K.
          <br />
          <span className="super">5</span> Greater capital city area and rest of state not available for QLD and
          National. For more information on greater capital city statistical areas, refer to ABS description{' '}
          <a
            href="https://www.abs.gov.au/ausstats/abs@.nsf/Lookup/by%20Subject/1270.0.55.001~July%202016~Main%20Features~Greater%20Capital%20City%20Statistical%20Areas%20(GCCSA)~10003"
            target="_blank"
            rel="noreferrer"
          >
            here
          </a>
          . In the refinance index ’National’ refers to the 5 mainland states of NSW, VIC, QLD, WA & SA.
          <br />
          <span className="super">6</span> Multiple index views can only be selected for one region at a time.
          <br />
        </p>
      </div>
      <div className="footer-bar">
        <FooterLogo width="100%" />
        <div className="footer-year">© PEXA {activeYear}</div>
      </div>
    </footer>
  )
}

export default Footer
